import React from 'react'
import { MatchClientModel } from '@sport1/types/sportData'
import Types from '@sport1/news-styleguide/Types'
import FanVotingLib from '@sport1/news-styleguide/FanVoting'
import OddsDisclaimer from '@/components/OddsDisclaimer'
import { useBetting } from '@/hooks/useBetting'
import useOddsRegistration from '@/hooks/useOddsRegistration'
import { useTracking } from '@/utils/tracking/TrackingProvider'

type FanVotingOptionsProps = {
    title: string
    votingOptions: Types.VoteOption[]
    hasVoted: boolean
    available: boolean
    onVote: (selectedIndex: number) => void
    match: MatchClientModel
}

const FanVotingOptions = ({
    match,
    votingOptions,
    hasVoted,
    onVote,
    available,
    title,
}: FanVotingOptionsProps) => {
    const { countryInfo } = useTracking()
    const bettingProperties = useBetting({
        match,
        scope: 'ticker',
        // TODO: we can not update bet-service-client because of sport1-components, maybe using S1_WIDGETS like in the App?
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        trackingCreation: 'fanvoting_liveticker',
        ignoreMatchStatus: true,
    })
    useOddsRegistration({ matchId: match.id, odds: bettingProperties?.odds })

    const twoWayVotingOptions =
        votingOptions.length > 2 ? [votingOptions[0], votingOptions[2]] : votingOptions

    const vote = (selectedIndex: number) => {
        /* TODO: adapt this in BetService Backend to provide just 2 options or add feature to distinguish between 2 or 3 options
            -> https://sport1digital.atlassian.net/browse/ML-6192 */
        // parse selected index 1 to 2 because we filtered the original index 1 out
        const parsedSelectedIndex =
            selectedIndex === 1 && votingOptions.length > 2 ? 2 : selectedIndex
        onVote(parsedSelectedIndex)
    }
    return (
        <>
            <FanVotingLib
                title={title}
                voteOptions={twoWayVotingOptions}
                hasVoted={hasVoted}
                onPress={!hasVoted && available ? vote : undefined}
                betProps={bettingProperties?.uiProperties}
                testID="fan-voting-element"
                userCountry={countryInfo?.country}
            />
            <OddsDisclaimer marginTop="spacing-6" testID="odds-disclaimer" spaceX="none" />
        </>
    )
}

export default FanVotingOptions
